<template>
  <div
    class="relative px-5 py-16 space-y-16 overflow-hidden lg:px-14 xl:px-20 2xl:px-12 md:py-14 lg:py-16 2xl:py-24 md:space-y-14 lg:space-y-16 2xl:space-y-24">
    <div class="w-full max-w-6xl mx-auto">
      <div v-if="showTitle" class="text-3xl text-center lg:text-4xl font-ww-bold mb-14" v-html="title"></div>
      <div
        class="flex flex-wrap justify-between md:flex-nowrap space-y-9 md:space-y-0 md:space-x-7 lg:space-x-16 xl:space-x-12">
        <div class="flex flex-wrap justify-center w-full md:w-1/2" v-for="(testimonial, index) in testimonials"
          :key="index">
          <div class="relative flex items-center justify-center w-full text-center">
            <svg role="presentation" class="w-full h-auto" xmlns="http://www.w3.org/2000/svg" width="541"
              height="227.067" viewBox="0 0 541 227.067">
              <path id="Path_714" data-name="Path 714" d="M0,6H541V207H329.943v26.067L288.1,207H0Z"
                transform="translate(0 -6)" fill="#F2F2F2"></path>
            </svg>
            <h2 class="absolute w-11/12 max-w-md pb-6 text-base font-ww-medium h4 lg:text-xl"
              v-html="testimonial.quote"></h2>
          </div>
          <div class="detailbox flex items-center w-full max-w-lg relative z-10 pr-6 lg:pr-10 space-x-3.5 md:space-x-6">
            <div class="w-full text-right pt-2.5 lg:pt-6">
              <p class="text-base font-ginger pb-0.5" v-html="testimonial.author"></p>
              <p class="h-8 text-xs" v-html="testimonial.profession"></p>
            </div>
            <nuxt-img class="block w-20 -mt-10 lg:w-28 xl:w-36 md:-mt-12 xl:-mt-16" width="150" height="150"
              loading="lazy" format="webp" :alt="testimonial.author" :src="testimonial.imageSrc"></nuxt-img>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: "Recommended by Professionals"
  },
  showTitle: {
    type: Boolean,
    default: false
  },
  textLeft: {
    type: Boolean,
    default: false
  },
  testimonials: {
    type: Array,
    default: () => [
      {
        quote: 'Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation.',
        author: 'Dr. Aaron Oxenrider',
        profession: 'Board Certified Chiropractic Physician and Regenerative Medicine Expert',
        imageSrc: 'assets/images/doctor2.jpg'
      },
      {
        quote: 'Low acid coffee Best tasting low acid coffee ever! And it’s great on your teeth!',
        author: 'Dr. Gary Sanchez',
        profession: 'Board Certified Dentist',
        imageSrc: 'assets/images/doctor1.jpg'
      }
    ]
  }
});

defineBuilderComponent({
  friendlyName: "Reviews3",
  inputs: [
    {
      name: "title",
      type: "string",
      friendlyName: "Title",
      defaultValue: "Recommended by Professionals"
    },
    {
      name: "showTitle",
      type: "boolean",
      friendlyName: "Show Title",
      defaultValue: false
    },
    {
      name: "textLeft",
      type: "boolean",
      friendlyName: "Text Left",
      defaultValue: false
    },
    {
      name: "testimonials",
      type: "list",
      friendlyName: "Testimonials",
      subFields: [
        {
          name: "quote",
          type: "richText",
          friendlyName: "Quote",
          defaultValue: "Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation."
        },
        {
          name: "author",
          type: "string",
          friendlyName: "Author",
          defaultValue: "Dr. Aaron Oxenrider"
        },
        {
          name: "profession",
          type: "string",
          friendlyName: "Profession",
          defaultValue: "Board Certified Chiropractic Physician and Regenerative Medicine Expert"
        },
        {
          name: "imageSrc",
          type: "file",
          friendlyName: "Author Image",
          allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
          defaultValue: "assets/images/doctor2.jpg"
        }
      ],
      defaultValue: [
        {
          quote: "Lifeboost Coffee is my favorite! It’s extremely low acid and easy on the stomach. It gets my 5 star recommendation.",
          author: "Dr. Aaron Oxenrider",
          profession: "Board Certified Chiropractic Physician and Regenerative Medicine Expert",
          imageSrc: "assets/images/doctor2.jpg"
        },
        {
          quote: "Low acid coffee Best tasting low acid coffee ever! And it’s great on your teeth!",
          author: "Dr. Gary Sanchez",
          profession: "Board Certified Dentist",
          imageSrc: "assets/images/doctor1.jpg"
        }
      ]
    }
  ]
});
</script>
